import { Navigation, EffectFade, Autoplay, Pagination, Swiper } from 'swiper';
// import lazyLoad from './modules/lazy-load';
import { setupUsedForm, submitUsedForm } from './modules/multi-brand-search-used';
import { setupNewForm, submitNewForm } from './modules/multi-brand-search-new';
import { customEvent } from '../modules/tracking/AnalyticsEvents';

// lazyLoad(document.querySelector('.cms-content-find-dealer__map'), document.querySelector('#dealer-locator'), function() { return true; });

const slideCount = document.querySelectorAll('.hero-bg-swiper .swiper-slide').length;
const autoplay = slideCount > 1
        ? {
            delay: 5000,
            disableOnInteraction: false,
            waitForTransition: true,
        }
        : false;

const swiper = new Swiper('.hero-bg-swiper', {
    modules: [Navigation, EffectFade, Pagination, Autoplay],
    navigation: {
        nextEl: '.homepage-swiper-button--next',
        prevEl: '.homepage-swiper-button--prev',
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    followFinger: false,
    grapCursor: false,
    allowTouchMove: false,
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets',
    },
    allowTouchMove: true,
    autoplay: autoplay,
});

swiper.on('click', (e) => {
    const slide = swiper.clickedSlide;
    if (slide && slide.dataset.link) {
        window.location.href = slide.dataset.link;
    }
});